export default __webpack_public_path__ + "static/about-4-d95c8440c919a9e3297b11d58f7e20d8.png";